import React, { useEffect, useState } from 'react';
import { Progress } from 'antd';
import { Button, Form, Modal } from '@maxtropy/components';
import dayjs from 'dayjs';
import { cpSyncProgress } from '../../../../../api/customer';

const SyncModal = ({ onCancel }: { onCancel: () => void }) => {
  const [progress, setProgress] = useState(0);
  const [date, setDate] = useState<string>();
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const poll = async () => {
      await cpSyncProgress().then(res => {
        if (res) {
          const progress = res?.progress >= 100 ? 100 : res?.progress < 0 ? 0 : res?.progress;
          setProgress(progress);
          res.time && setDate(res.time);
          // 进度完成后停止轮询
          if (progress === 100 && timer) {
            clearInterval(timer);
          }
        }
      });
    };
    poll();
    const interval = setInterval(poll, 30000); // 每 30 秒轮询一次
    setTimer(interval);

    return () => clearInterval(interval); // 卸载时清除定时器
  }, []);

  return (
    <Modal
      title="同步进度"
      open={true}
      contentClassName="modal-form-content"
      footer={
        <Button type="primary" onClick={onCancel}>
          确定
        </Button>
      }
      onCancel={onCancel}
    >
      <Form>
        <Form.Item label="上次同步时间">{date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : '--'}</Form.Item>
        <Form.Item label="同步进度">
          <Progress
            percent={progress}
            size="small"
            style={{ width: 240 }}
            strokeColor={{ from: '#51A1FF', to: '#51DBFF' }}
            trailColor="rgba(74,144,226,0.2)"
            status="active"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SyncModal;
